import { useEffect, useState } from 'react';
import { ArrowBack } from '@mui/icons-material';

// material-ui
import { Box, Button, Grid, Typography, Modal, TextField, FormControl, Select, MenuItem, Autocomplete } from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';

import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { Link, useNavigate } from 'react-router-dom';
import { axiosInstance } from 'utils/axios';

import { toast } from 'react-toastify';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 800,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const CreateCustomer = () => {
    const { t } = useTranslation();

    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();
    const [isLoading, setLoading] = useState(true);
    const [customers, setCustomers] = useState([]);
    const [customerGroups, setCustomerGroups] = useState([]);
    const [customerInquiries, setCustomerInquiries] = useState([]);
    const [customerStatus, setCustomerStatus] = useState([]);
    const [customerBankVendor, setCustomerBankVendor] = useState([]);
    const [memberLevels, setMemberLevels] = useState([]);
    const [memberTypes, setMemberTypes] = useState([]);

    const [createAssignedUserName, setCreateAssignedUserName] = useState('');
    const [createCustomerName, setCreateCustomerName] = useState('');
    const [createCustomerBank, setCreateCustomerBank] = useState('');
    const [createCustomerBankAcc, setCreateCustomerBankAcc] = useState('');
    const [createCustomerBankAccHolder, setCreateCustomerBankAccHolder] = useState('');
    const [loginUsername, setLoginUsername] = useState('');
    const [nrc, setNrc] = useState('');
    const [birthday, setBirthday] = useState(dayjs(''));
    const [phoneNumber, setPhoneNumber] = useState('');
    const [loginPassword, setLoginPassword] = useState('');
    const [isLoginDisable, setIsLoginDisable] = useState(false);
    const [createCustomerGroup, setCreateCustomerGroup] = useState('');
    const [createCustomerInquiry, setCreateCustomerInquiry] = useState('');
    const [createCustomerRecommend, setCreateCustomerRecommend] = useState('');
    const [createCustomerStatus, setCreateCustomerStatus] = useState('1');
    const [createCustomerRemark, setCreateCustomerRemark] = useState('');
    const [createCustomerDate, setCreateCustomerDate] = useState(dayjs(''));
    const [customerNameOptions, setCustomerNameOptions] = useState([]);
    const [userNameOptions, setUserNameOptions] = useState([]);
    const [customerReferralCodesOptions, setCustomerReferralCodesOptions] = useState([]);
    const [loginUsernameOptions, setLoginUsernameOptions] = useState([]);
    const [bankAccountNumberOptions, setBankAccountNumberOptions] = useState([]);
    const [bankAccountHolderNameOptions, setBankAccountHolderNameOptions] = useState([]);
    const [createCustomerReferralCode, setCreateCustomerReferralCode] = useState('');
    const [createCustomerMemberLevel, setCreateCustomerMemberLevel] = useState(0);
    const [createCustomerMemberType, setCreateCustomerMemberType] = useState(0);
    const navigate = useNavigate();
    const [insertBtnDisabled, setInsertBtnDisable] = useState(false);

    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);

    const [agentCode, setAgentCode] = useState()

    const warningAlert = (message) => {
        toast.warning(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const successAlert = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const errorAlert = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const fetchAgentCode = async () => {
        try {
            const res = await axiosInstance.get("/User/AgentCode",{
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })

            if(res.status === 200){
                setAgentCode(res.data);
                // setLoginUsername(res.data);
            }else{
                
            }
        } catch (error) {
            console.log(error)
        }
    }

    const setAgentCodeByUserName = async (userName) => {
        if (userName != ''){
            try {
                const res = await axiosInstance.get(`/User/${userName}/AgentCode`,{
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
    
                if(res.status === 200){
                    setAgentCode(res.data);
                    // setLoginUsername(res.data);
                }else{
                    
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    //fetch dropdowns start
    const fetchDropDowns = async () => {

        const fetchBankAccountNumber = async () => {
            const customerGroups = await axiosInstance.get('/Customer/Autofill/BankDetails', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setBankAccountNumberOptions(customerGroups.data.bankAccountNumber);
        };
        fetchBankAccountNumber();

        const fetchBankAccountHolderName = async () => {
            const customerGroups = await axiosInstance.get('/Customer/Autofill/BankDetails', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setBankAccountHolderNameOptions(customerGroups.data.bankAccountHolderName);
        };
        fetchBankAccountHolderName();

        const fetchCustomerGroups = async () => {
            const customerGroups = await axiosInstance.get('/CustomerGroup', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setCustomerGroups(customerGroups.data);
        };
        fetchCustomerGroups();

        const fetchCustomerInquiries = async () => {
            const customerInquiries = await axiosInstance.get('/CustomerInquiryFrom', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setCustomerInquiries(customerInquiries.data);
        };
        fetchCustomerInquiries();

        const fetchCustomerStatus = async () => {
            const customerStatus = await axiosInstance.get('/CustomerStatus', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setCustomerStatus(customerStatus.data);
        };
        fetchCustomerStatus();

        const fetchCustomerBankVendor = async () => {
            const customerBankVendor = await axiosInstance.get('/BankVendor', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setCustomerBankVendor(customerBankVendor.data);
        };
        fetchCustomerBankVendor();

        const fetchMemberLevels = async () => {
            const memberLevel = await axiosInstance.get('/MemberLevels', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setMemberLevels(memberLevel.data);
        };
        fetchMemberLevels();

        const fetchMemberTypes = async () => {
            const memberTypes = await axiosInstance.get('/MemberTypes', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setMemberTypes(memberTypes.data);
        };
        fetchMemberTypes();
    };
    //fetch dropdowns end

    //create customer start
    const submitCreateCustomer = async (e) => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);

        const isDisable = isLoginDisable === 'true';

        // console.log('name is :', createCustomerName);
        // console.log('bankVendorID is :', createCustomerBank * 1);
        // console.log('bankAccount is :', createCustomerBankAcc);
        // console.log('bankHolderName is :', createCustomerBankAccHolder);
        // console.log('customerGroupID is :', createCustomerGroup * 1);
        // console.log('inquiryFromID is :', createCustomerInquiry * 1);
        // console.log('customerStatusID is :', createCustomerStatus);
        // console.log('customerLoginUsername is :', loginUsername);
        // console.log('customerLoginPassword is :', loginPassword);
        // console.log('customerLoginIsDisabled is :', isDisable);

        if (
            createAssignedUserName === '' ||
            createCustomerName === '' ||
            createCustomerStatus === '' ||
            loginUsername === '' ||
            loginPassword === '' ||
            (isDisable !== true && isDisable !== false)
        ) {
            warningAlert('Please Fill all required fields.');
            return;
        }
        setInsertBtnDisable(true);
        try {
            const res = await axiosInstance.post(
                '/CustomerDetail',
                {
                    name: createCustomerName,
                    bankVendorID: createCustomerBank * 1,
                    bankAccount: createCustomerBankAcc,
                    bankHolderName: createCustomerBankAccHolder,
                    customerGroupID: createCustomerGroup * 1,
                    inquiryFromID: createCustomerInquiry * 1,
                    customerStatusID: createCustomerStatus,
                    customerLoginUsername: loginUsername,
                    customerLoginPassword: loginPassword,
                    customerLoginIsDisabled: isDisable,
                    recommendBy: createCustomerRecommend,
                    followUpDate: createCustomerDate.isValid() ? createCustomerDate.format('YYYY-MM-DD') : '',
                    remark: createCustomerRemark,
                    nrc: nrc,
                    birthday: birthday,
                    phoneNumber: phoneNumber,
                    referralCode: createCustomerReferralCode,
                    memberLevelID: createCustomerMemberLevel,
                    memberTypeID: createCustomerMemberType,
                    assignedUserName: createAssignedUserName
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.status === 200) {
                successAlert('Created customer successfully.');
                navigate('/customer');
            } else {
                if (res.response.data.errorCode) {
                    const errorCode = res.response.data.errorCode;

                    if (errorCode === 'CERR002') {
                        errorAlert('Duplicate client name error message');
                    } else if (errorCode.startsWith('CERR')) {
                        errorAlert(res.response.data.errorMessage);
                    } else {
                        errorAlert('Something went wrong.');
                    }
                } else {
                    errorAlert('Something went wrong.');
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setInsertBtnDisable(false); // Reset Disable state after request is completed
        }
    };

    const fetchGeneratePassword = async () => {
        const customerStatus = await axiosInstance.get('/GenerateRandomPassword', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        setLoginPassword(customerStatus.data);
    };

    //fetch customer names for autocomplete start
    const fetchCustomerNamesOptions = async () => {
        try {
            const res = await axiosInstance.get('/Customer/Names', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setCustomerNameOptions(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    //fetch customer names for autocomplete start
    const fetchUserNamesOptions = async () => {
        try {
            const res = await axiosInstance.get('/UserNames/Options', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setUserNameOptions(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    const fetchCustomerReferralCodesOptions = async () => {
        try {
            const res = await axiosInstance.get('/Customer/ReferralCodes', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setCustomerReferralCodesOptions(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const fetchLoginUsername = async () => {
        const customerGroups = await axiosInstance.get('/Customer/LoginUserNames', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        setLoginUsernameOptions(customerGroups.data);
    };

    const CreateCustomerModal = () => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = (e, reason) => {
            // if (!e.target.classList.contains('MuiMenuItem-root')) {
            setOpen(false);
            // }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: deepPurple[500],
                        color: 'white',
                        marginLeft: 'auto',
                        marginBottom: '20px',
                        marginRight: '20px'
                    }}
                >
                    Create Customer
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <Box sx={style}></Box>
                </Modal>
            </>
        );
    };
    //create customer end
    const [isUserAllowEdit, setIsUserAllowEdit] = useState(false);
    const fetchIsUserAllowEdit = async () => {
        try {
            const res = await axiosInstance.get('IsAllowEdit', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setIsUserAllowEdit(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        setLoading(false);
        // fetchDropDowns();
        fetchCustomerNamesOptions();
        fetchUserNamesOptions();
        fetchLoginUsername();
        // fetchCustomerReferralCodesOptions();
        // fetchAgentCode();
        // fetchIsUserAllowEdit();
    }, []);

    return (
        <Grid container item xs={12}>
            <Grid item container xs={12}>
                <Link
                    to="/customer"
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '5px',
                        marginBottom: '30px',
                        textDecoration: 'none',
                        color: deepPurple[500]
                    }}
                >
                    <ArrowBack />
                    {t("customer.back")}
                </Link>
            </Grid>
            <Box
                id="modal-modal-description"
                sx={{
                    // height:"300px",
                    overflowY: 'auto'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}
                >
                    <Typography id="modal-modal-title" variant="h3" component="h2">
                        {t("customer.createCustomer")}
                    </Typography>
                </Box>
                <Grid item container xs={12} sx={{ mt: 2 }}>
                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <span style={{ color: 'red' }}>*</span> {t("customer.administrator")} :
                            </Typography>
                            <Autocomplete
                                id="outlined-basic"
                                variant="outlined"
                                value={createAssignedUserName}
                                onChange={(event, newValue) => {
                                    setAgentCodeByUserName(newValue);
                                }}
                                inputValue={createAssignedUserName}
                                onInputChange={(event, newInputValue) => {
                                    setCreateAssignedUserName(newInputValue);
                                }}
                                options={userNameOptions}
                                sx={{ width: 170 }}
                                renderInput={(params) => <TextField {...params} />}
                                disableClearable
                            />
                        </Box>
                    </Grid>
                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}></Grid>

                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <span style={{ color: 'red' }}>*</span>{t("customer.loginUserName")} ：
                            </Typography>

                            <Autocomplete
                                variant="outlined"
                                value={loginUsername}
                                onChange={(event, newValue) => {
                                    setLoginUsername(newValue);
                                }}
                                inputValue={loginUsername}
                                onInputChange={(event, newInputValue) => {
                                    setLoginUsername(newInputValue);
                                }}
                                id="controllable-states-demo"
                                options={loginUsernameOptions}
                                sx={{ width: 170 }}
                                renderInput={(params) => <TextField {...params} />}
                                disableClearable
                            />
                        </Box>
                    </Grid>

                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <span style={{ color: 'red' }}>*</span>{t("customer.password")} ：
                            </Typography>
                            <TextField
                                id="outlined-basic"
                                variant="outlined"
                                value={loginPassword}
                                onChange={(e) => setLoginPassword(e.target.value)}
                            />
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '100px',
                                    backgroundColor: deepPurple[500]
                                }}
                                onClick={() => fetchGeneratePassword()}
                            >
                                {t("customer.autoGenerate")}
                            </Button>
                        </Box>
                    </Grid>
                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <span style={{ color: 'red' }}>*</span>{t("customer.name")} :
                            </Typography>
                            <Autocomplete
                                id="outlined-basic"
                                variant="outlined"
                                value={createCustomerName}
                                onChange={(event, newValue) => {
                                    setCreateCustomerName(newValue);
                                }}
                                inputValue={createCustomerName}
                                onInputChange={(event, newInputValue) => {
                                    setCreateCustomerName(newInputValue);
                                }}
                                options={customerNameOptions}
                                sx={{ width: 170 }}
                                renderInput={(params) => <TextField {...params} />}
                                disableClearable
                            />
                        </Box>
                    </Grid>

                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                {t("customer.phoneNumber")} ：
                            </Typography>
                            <TextField
                                id="outlined-basic"
                                variant="outlined"
                                value={phoneNumber}
                                onChange={(e) => setPhoneNumber(e.target.value)}
                            />
                        </Box>
                    </Grid>

                    {/* <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                NRC :
                            </Typography>
                            <TextField id="outlined-basic" variant="outlined" value={nrc} onChange={(e) => setNrc(e.target.value)} />
                        </Box>
                    </Grid> */}

                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                {t("customer.recommendBy")} ：
                            </Typography>
                            <Autocomplete
                                id="outlined-basic"
                                variant="outlined"
                                value={createCustomerRecommend}
                                onChange={(event, newValue) => {
                                    setCreateCustomerRecommend(newValue);
                                }}
                                inputValue={createCustomerRecommend}
                                onInputChange={(event, newInputValue) => {
                                    setCreateCustomerRecommend(newInputValue);
                                }}
                                options={loginUsernameOptions}
                                sx={{ width: 170 }}
                                renderInput={(params) => <TextField {...params} />}
                                disableClearable
                            />
                            {/* <TextField
                                id="outlined-basic"
                                variant="outlined"
                                value={createCustomerRecommend}
                                onChange={(e) => setCreateCustomerRecommend(e.target.value)}
                            /> */}
                        </Box>
                    </Grid>
                </Grid>
                <Button
                    variant="contained"
                    sx={{
                        display: 'block',
                        mx: 'auto',
                        width: '150px',
                        backgroundColor: deepPurple[500],
                        marginTop: '50px'
                    }}
                    onClick={() => submitCreateCustomer()}
                    disabled={insertBtnDisabled}
                >
                    {t("customer.confirmCreateCustomer")}
                </Button>
                {/* {isUserAllowEdit &&
                } */}
            </Box>
        </Grid>
    );
};

export default CreateCustomer;
